<a
  class="content-card__parent"
  [routerLink]="card() | slug"
  (click)="triggerViewItem(card())">
  <div class="content-card content-card--{{ lowerCaseTypeName() }} {{ classes() }}">
    <ng-container
      [ngTemplateOutletContext]="{ $implicit: card() }"
      [ngTemplateOutlet]="userCard() ? cardUser : cardContent"></ng-container>
  </div>
</a>

<ng-template
  #cardContent
  let-card
  [typeToken]="cardContentToken">
  <div class="content-card__image">
    <div class="content-card__info">
      <div class="content-card__info__location">
        <small
          class="medium"
          sharryEllipsisTooltip
          >{{ distanceBiggerThanOne() ? (card?.distance | number: '1.0-0') + 'km' : '' }}{{ formattedaddress() }}</small
        >
      </div>
      <button
        mat-icon-button
        (click)="onLike(card); $event.preventDefault(); $event.stopImmediatePropagation(); $event.stopPropagation()">
        <sharry-icon
          registryName="bookmark-simple-stroked"
          svgClass="svg-icon"
          [ngClass]="{ active: bookmarked() }"
          [ssr]="true">
        </sharry-icon>
      </button>
    </div>
    <picture data-image-loading
      ><img
        [alt]="card?.title"
        [src]="card?.coverPicture?.bestVersion?.url"
    /></picture>
    @if ($any(card)?.nextUpcomingVariant?.discount) {
      <span class="content-card__badge content-card__badge--{{ $any(card)?.nextUpcomingVariant?.discount?.kind }}">{{
        'content-card.' + $any(card)?.nextUpcomingVariant?.discount?.kind | i18next
      }}</span>
    }
    @if ($any(card)?.soldBySharryland) {
      <span class="content-card__sold-by-sharryland">{{ 'content-card.sold_by_sharryland' | i18next }}</span>
    }
  </div>
  <div class="content-card__description-container">
    <div class="content-card__image__type">
      <img
        alt="tipologia"
        [src]="imgSrc()" />
    </div>
    <div
      class="content-card__category-container"
      sharryEllipsisTooltip="1"
      [innerHTML]="$any(card) | colorize: 'short'"></div>

    <p
      class="content-card__title bigger"
      sharryEllipsisTooltip="2">
      {{ card?.title }}
    </p>
    @switch (card.contentType) {
      @case ('wonder') {
        <ng-container
          [ngTemplateOutlet]="cardWonder"
          [ngTemplateOutletContext]="{ $implicit: card }"></ng-container>
      }
      @case ('sharry') {
        <ng-container
          [ngTemplateOutlet]="cardSharry"
          [ngTemplateOutletContext]="{ $implicit: card }"></ng-container>
      }
      @case ('event') {
        <ng-container
          [ngTemplateOutlet]="cardEvent"
          [ngTemplateOutletContext]="{ $implicit: card }"></ng-container>
      }
    }
  </div>
</ng-template>

<ng-template
  #cardSharry
  let-card
  [typeToken]="cardSharryToken">
  <p class="content-card__description">
    @if (card.requiresPayment) {
      <span class="content-card__price">
        <span class="bold">{{
          'content-card.price'
            | i18next
              : {
                  price: card.nextUpcomingVariant?.discountedPrice | currency: 'EUR' : 'symbol-narrow',
                }
        }}</span>
        @if (card.nextUpcomingVariant?.discount) {
          <small class="content-card__old-price">
            {{ card.nextUpcomingVariant?.price | currency: 'EUR' : 'symbol-narrow' }}
          </small>
        }
      </span>
    } @else {
      <span class="content-card__price">
        <span class="bold">{{ freeSharryKind() | i18next }}</span>
      </span>
    }
    @if ([$any(card).nextUpcomingVariant] | variantDate) {
      <span class="content-card__description__period">
        {{ [$any(card).nextUpcomingVariant] | variantDate | date: 'd MMM yyyy'
        }}{{ card?.variantDuration?.duration ? '&nbsp;-' : null }}
      </span>
    }
    @if (card?.variantDuration?.duration) {
      <span class="content-card__description__period">
        {{ card.variantDuration.duration }}&nbsp;{{ durationType() | i18next }}
      </span>
    }
  </p>
  <div class="content-card__owner">
    <span [avatar]="{ user: card?.owner, size: 'small', imgSize: '36px' }"></span>
    <small
      class="semibold"
      sharryEllipsisTooltip="1"
      >{{ card?.owner | userName }}</small
    >
  </div>
</ng-template>

<ng-template
  #cardEvent
  let-card
  [typeToken]="cardEventToken">
  <p
    class="content-card__subtitle"
    sharryEllipsisTooltip="2">
    {{ card.subtitle }}
  </p>
  <p
    class="content-card__description semibold content-card__description--more-dark"
    sharryEllipsisTooltip="1">
    @if (finishedEvent()) {
      {{ 'event.reservation.finished' | i18next }}
    } @else if (nonRecorsiveEvent()) {
      {{ card.nextEventInstance.beginsAt | date: 'd MMM' }} - {{ card.nextEventInstance.endsAt | date: 'd MMM' }}
    } @else {
      {{ card.nextUpcomingInstanceDate | date: 'd MMM' }}
    }
  </p>
</ng-template>

<ng-template
  #cardWonder
  let-card
  [typeToken]="cardWonderToken">
  <p
    class="content-card__subtitle"
    sharryEllipsisTooltip="2">
    {{ card.subtitle }}
  </p>
</ng-template>

<ng-template
  #cardUser
  let-card
  [typeToken]="cardUserToken">
  <div class="content-card__image content-card__image--user">
    <div class="content-card__info">
      <div class="content-card__info__location">
        <small
          class="medium content-card__info__location--user"
          sharryEllipsisTooltip
          >{{ distanceBiggerThanOne() ? (card?.distance | number: '1.0-0') + 'km' : '' }}{{ formattedaddress() }}</small
        >
      </div>
      <button
        mat-icon-button
        (click)="onLike(card); $event.preventDefault(); $event.stopImmediatePropagation(); $event.stopPropagation()">
        <sharry-icon
          registryName="bookmark-simple-stroked"
          svgClass="svg-icon"
          [ngClass]="{ active: bookmarked() }"
          [ssr]="true">
        </sharry-icon>
      </button>
    </div>

    <div class="content-card__user">
      <div
        class="content-card__user__image is-mobile-not-ipad"
        [avatar]="{ user: $any(card), size: 'small', imgSize: '150px' }"></div>
      <div
        class="content-card__user__image is-not-mobile-not-ipad"
        [avatar]="{ user: $any(card), size: 'small', imgSize: '100px' }"></div>
    </div>
    @if (card.isSmallOrganisation) {
      <span
        class="content-card__user__badge"
        [ngClass]="{
          'content-card__user__badge--trusted': trustedUser(),
          'content-card__user__badge--sharryland-partner': card.sharrylandPartner,
        }"
        >PRO
        @if (trustedUser()) {
          <sharry-icon
            name="star"
            type="phosphor"
            svgClass="content-card__user__badge__icon"></sharry-icon>
        }
      </span>
    }
  </div>
  <div class="content-card__description-container">
    <div
      class="content-card__category-container--user"
      sharryEllipsisTooltip="1"
      [innerHTML]="$any(card) | colorize: 'short'"></div>

    <p
      class="content-card__title bigger"
      sharryEllipsisTooltip="2">
      {{ card | userName }}
    </p>
    <p
      class="content-card__description"
      sharryEllipsisTooltip="2">
      {{ card.whoIAm }}
    </p>
    @if (card?.ambassador) {
      <p
        class="content-card__description semibold"
        sharryEllipsisTooltip="1">
        <sharry-icon
          name="ambassador-no-circle"
          type="custom"
          svgClass="svg-icon">
        </sharry-icon>
        <span>{{ 'profile.ambassador' | i18next }}</span>
      </p>
    }
    @if (card?.isPaladin) {
      <p
        class="content-card__description semibold"
        sharryEllipsisTooltip="1">
        <sharry-icon
          name="paladin"
          type="custom"
          svgClass="svg-icon">
        </sharry-icon>
        <span>{{ 'profile.is-paladin' | i18next }}</span>
      </p>
    }
    @if (card?.friendlyMunicipality) {
      <p
        class="content-card__description semibold"
        sharryEllipsisTooltip="1">
        <sharry-icon
          name="friendly-municipality"
          type="custom"
          svgClass="svg-icon">
        </sharry-icon>
        <span>{{ 'profile.friendly-municipality' | i18next }}</span>
      </p>
    }
  </div>
</ng-template>
